import { Box, Stack, Typography } from "@mui/material"

import { Container, Image, Link, type FC, type FCWC } from ".."
import type { FooterCTAType } from "../../graphql/types"

const PreFooterCTA: FC<FooterCTAType> = ({ id, title, type, items }) => {
  return (
    <Container>
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems="center"
        justifyContent={{ xs: "space-between", lg: "center" }}
        flexWrap="nowrap"
        columnGap={{ sm: 0, lg: 7.5 }}
        rowGap={5}
        borderTop={(theme) => `1px solid ${theme.palette["neutral.200"].main}`}
        py={{ xs: 10, md: 27.5 }}
      >
        {items?.map(({ title, link, image }, i) => (
          <CTAItem key={i}>
            <CTAImage src={image?.variants?.[0]?.url} alt={title} />
            <Stack justifyContent="center" alignItems="flex-start">
              <CTAItemTitle>{title}</CTAItemTitle>
              <Box>
                <Link href={link.uri} variant="link.sm">
                  {link.title}
                </Link>
              </Box>
            </Stack>
          </CTAItem>
        ))}
      </Stack>
    </Container>
  )
}
export default PreFooterCTA

const CTAImage: FC<{ src: string; alt: string }> = ({ src, alt }) => (
  <Box sx={{ aspectRatio: { md: "1" }, maxWidth: { md: 180 } }}>
    <Image
      src={src}
      alt={alt}
      data-chromatic="ignore"
      sx={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
    />
  </Box>
)

const CTAItem: FCWC = ({ children }) => (
  <Box
    minWidth={{ md: 180, lg: 326 }}
    flexBasis={{ md: "calc(100% / 3 - 40px / 3 * 2)" }}
    display="grid"
    gridTemplateColumns={{ xs: "clamp(0px, 37.04%, 180px) auto", xl: "auto 1fr" }}
    alignItems="center"
    columnGap={{ md: 4, lg: 10 }}
    p={{ md: 4, lg: 7.5 }}
  >
    {children}
  </Box>
)

const CTAItemTitle: FCWC = ({ children }) => (
  <Typography component="h2" variant="heading.sm" mb={2} sx={{ whiteSpace: "nowrap" }}>
    {children}
  </Typography>
)
